import { gql } from "@apollo/client";

export const FOLLOWERS_QUERY = gql`
  query UserFollowers($userId: String!) {
    getUser(_id: $userId) {
      following {
        edges {
          cursor
          node {
            username
            rank
            userGroup {
              type
            }
            avatar
            _id
            discord {
              avatar
              id
              username
            }
          }
        }
      }
      followers {
        edges {
          cursor
          node {
            username
            rank
            userGroup {
              type
            }
            avatar
            _id
            discord {
              avatar
              id
              username
            }
          }
        }
      }
      followerCount
      followingCount
    }
  }
`;

export const FOLLOWERS_PAGINATED_QUERY = gql`
  query UserFollowersPaginated(
    $userId: String!
    $first: Int
    $after: String
    $includeFollowers: Boolean!
    $includeFollowing: Boolean!
  ) {
    getUser(_id: $userId) {
      followers(first: $first, after: $after) @include(if: $includeFollowers) {
        edges {
          cursor
          node {
            username
            rank
            userGroup {
              type
            }
            avatar
            _id
            discord {
              avatar
              id
              username
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      following(first: $first, after: $after) @include(if: $includeFollowing) {
        edges {
          cursor
          node {
            username
            rank
            userGroup {
              type
            }
            avatar
            _id
            discord {
              avatar
              id
              username
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      followerCount
      followingCount
    }
  }
`;

export const MY_FOLLOWERS_QUERY = gql`
  query MyFollowers($clips: Boolean!, $profiles: Boolean!) {
    myFollowing(clips: $clips, profiles: $profiles) {
      profiles {
        followers {
          username
          rank
          avatar
          _id
          userGroup {
            type
          }
          discord {
            avatar
            id
            username
          }
        }
        following {
          username
          rank
          avatar
          _id
          userGroup {
            type
          }
          discord {
            avatar
            id
            username
          }
        }
      }
    }
  }
`;

export const FOLLOW_UNFOLLOW_MUTATION = gql`
  mutation MutateFollowers($userToFollow: String!, $follow: Boolean!) {
    followUnfollow(userToFollow: $userToFollow, follow: $follow)
  }
`;
